/**
 * Represents the type of capitalization to apply to text.
 */
export enum CapitalizeType {
  lowercase = 'lowercase',
  uppercase = 'uppercase',
  titlecase = 'titlecase',
  sentencecase = 'sentencecase',
}
